import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectConsoleComponent } from './select-console/select-console.component';
import { EquipmentSelectionComponent } from './equipment-selection/equipment-selection.component';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from 'src/app/core/core.module';
import { MultiSelectionComponent } from './multi-selection/multi-selection.component';

@NgModule({
  declarations: [SelectConsoleComponent, EquipmentSelectionComponent, MultiSelectionComponent],
  imports: [CommonModule, TranslateModule, CoreModule],
  exports: [SelectConsoleComponent, EquipmentSelectionComponent, MultiSelectionComponent],
})
export class SelectorsModule {}
